module.exports = __webpack_public_path__ + "img/antigua_and_barbuda.740768c.webp";